module.exports = __webpack_public_path__ + "img/0-0.548c51c8.gif";